import { VStack } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { Button } from "ui/Button/Button";
import { isKnownPartner, PartnerLogo } from "ui/PartnerLogo/PartnerLogo";
import { BodyM, HeaderS } from "ui/Typography/Typography";
import { getShortOrderNumber } from "utils/formats";

import { TableLine } from "./TableLine";

type ExternalProviderOrderNoticeProps = {
  externalProvider: string;
  orderNumber: string | null;
  onAcknowledge: () => void;
};

// Shown instead of the order details when the scanned or offered order is packed by an external
// provider. getOrderDetails returns no order for it, so only the number and provider are known.
export function ExternalProviderOrderNotice({
  externalProvider,
  orderNumber,
  onAcknowledge,
}: ExternalProviderOrderNoticeProps) {
  const intl = useIntl();

  return (
    <VStack spacing="s200" w="100%" data-testid="external-provider-order-notice">
      <HeaderS textAlign="center">
        <FormattedMessage id="components.picking.external-provider-order.title" />
      </HeaderS>

      <PartnerLogo partner={externalProvider} />

      <BodyM textAlign="center" color="grey.700">
        {isKnownPartner(externalProvider) ? (
          <FormattedMessage
            id="components.picking.external-provider-order.description"
            values={{ provider: externalProvider }}
          />
        ) : (
          <FormattedMessage id="components.picking.external-provider-order.description.unknown-provider" />
        )}
      </BodyM>

      {orderNumber && (
        <TableLine
          label={intl.formatMessage({ id: "components.picking.order-summary.order-number" })}
          rightElem={getShortOrderNumber(orderNumber)}
        />
      )}

      <Button
        onClick={onAcknowledge}
        isFullWidth
        size="lg"
        data-testid="button-acknowledge-external-provider-order"
      >
        <FormattedMessage id="generic.actions.got-it" />
      </Button>
    </VStack>
  );
}
